/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreateBranch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 4V2h2v2h2v2h-2v2h-2V6h-2V4zM8 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM4 6a4 4 0 1 1 5 3.874V13a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3h2v3a4 4 0 0 1-4 4h-2.29A4 4 0 1 1 7 14.626V9.874A4.002 4.002 0 0 1 4 6zm4 10.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCreateBranch as CreateBranch };
